import React, { useMemo, useEffect, useState } from 'react'
import "./resultHeader.scss"
import { useSelector } from 'react-redux'
import { Select1dCurrentGameTime, Select1dLastWinCard, Select1dUserWallet } from '../../../redux/1d-slice/gameInfo1dSlice.js'
import moment from 'moment'
import TimerControl from './TimerControl'
import { AuthState } from "../../../context/AuthProvider";

function ResultHeader() {

    let currentDrawTime = useSelector(Select1dCurrentGameTime)
    let last_win_cards = useSelector(Select1dLastWinCard)
    const [timer, setTimer] = useState(null)

    let { userDetail } = AuthState()
    let userWallet = useSelector(Select1dUserWallet)

    useEffect(() => {
        let timeInterval = setInterval(() => {
            setTimer(moment().format('hh:mm:ss A'))
        }, 1000);

        return () => {
            clearInterval(timeInterval)
        }
    }, [])

    // Convert last_win_cards → [{num: 69, time: "06:00 PM"}, ...]
    let sortedCards = useMemo(() => {
        if (!last_win_cards?.length) return [];

        let arr = last_win_cards.map(card => {
            const [num, , time] = card.split("|");
            return {
                number: num,
                rawTime: time,
                momentTime: moment(time, "hh:mm A")
            };
        });

        // SORT BY TIME DESCENDING
        arr.sort((a, b) => b.momentTime - a.momentTime);

        return arr;
    }, [last_win_cards]);


    return (
        <>
            <table width="100%" className="hover-table">
                <tbody>
                    <tr>
                        <th
                            width="10%"
                            rowSpan={2}
                            className='result_head'
                            style={{
                                height: "30px !important", backgroundColor: "#F8F7A3", fontSize: '16px',
                                border: '1px solid black',
                            }}
                        >
                            Result: {currentDrawTime
                                ? moment(currentDrawTime, "DD/MM/YYYY, hh:mm:ss A")
                                    .subtract(5, "minutes")
                                    .format("hh:mm A")
                                : ""}

                            <br />
                            {currentDrawTime ? moment(currentDrawTime, 'D/M/yyyy, h:mm:ss A').format('D/M/yyyy') : ''}
                        </th>

                        {/* PRINT LAST WIN NUMBERS */}
                        {sortedCards.map((item, i) => (
                            <td
                                key={i}
                                className="san_res_col text-center"
                                style={{
                                    fontSize: '24px',
                                    fontWeight: 'bold',
                                    color: 'red',
                                    backgroundColor: i === 0
                                        ? "#00be56ff" : "#d9d9d9",
                                    border: '1px solid black',
                                }}
                            >
                                {item.number} <br />
                                <span style={{ fontSize: '14px', fontWeight: 'bold', color: 'black' }}>
                                    {item.rawTime
                                        ? moment(item.rawTime, "hh:mm:ss A").format("hh:mm A")
                                        : ""}
                                </span>
                            </td>
                        ))}


                    </tr>
                    <tr style={{
                        backgroundColor: "#d9d9d9",
                    }}>
                        <th colSpan={2} scope="col" style={{ fontSize: '18px', border: '1px solid black', borderCollapse: 'collapse' }}>Time : {timer || '00:00:00'}</th>
                        <th colSpan={2} scope="col" style={{ fontSize: '18px', border: '1px solid black', borderCollapse: 'collapse' }}>Draw Time : {currentDrawTime ? moment(currentDrawTime, 'D/M/yyyy, h:mm:ss A').format('h:mm A') : ''}</th>
                        <th colSpan={2} scope="col" style={{ fontSize: '18px', border: '1px solid black', borderCollapse: 'collapse', color: 'red' }}>Time Left : <TimerControl /></th>
                        <th colSpan={2} scope="col" style={{ fontSize: '18px', border: '1px solid black', borderCollapse: 'collapse' }}>Id :{userDetail?.user_name || ''}</th>
                        <th colSpan={2} scope="col" style={{ fontSize: '18px', border: '1px solid black', borderCollapse: 'collapse' }}>Balance : {userWallet || 0}</th>
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default ResultHeader
